import { useState } from "react";
import { Bell, BellRing } from "lucide-react";
import { toast } from "sonner";
import { pushAvailability, subscribePush } from "@/lib/push";
import { waLink } from "@/lib/store";
import { InstallSteps, pushErrorText } from "./AlertsSection";
import { WhatsAppIcon } from "./WhatsAppIcon";

const WhatsAppAlert = ({ query }) => (
  <a data-testid="search-alert-whatsapp" target="_blank" rel="noopener noreferrer"
    href={waLink(`Olá, RC iPhones! Procurei "${query}" no site e não encontrei. Podem me avisar quando chegar?`)}
    className="inline-flex items-center gap-2 text-sm font-semibold text-[#25D366] hover:underline">
    <WhatsAppIcon className="h-4 w-4" /> Prefiro ser avisado pelo WhatsApp
  </a>
);

export const ArrivalAlert = ({ query, onAlert }) => {
  const [state, setState] = useState("idle");

  const ask = async () => {
    const avail = pushAvailability();
    if (avail !== "ok") {
      setState(avail === "ios-install" ? "ios" : "fallback");
      return;
    }
    setState("busy");
    try {
      await subscribePush({ want: query });
      setState("done");
      onAlert();
      toast.success("Combinado! Avisamos quando chegar.");
    } catch (e) {
      setState("fallback");
      toast.error(pushErrorText(e));
    }
  };

  if (state === "done") {
    return (
      <p data-testid="search-alert-done" className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-300">
        <BellRing className="h-4 w-4" /> Você será avisado quando “{query}” chegar.
      </p>
    );
  }
  return (
    <div className="space-y-4">
      <button data-testid="search-alert-button" onClick={ask} disabled={state === "busy"}
        className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10 disabled:opacity-60">
        <Bell className="h-4 w-4" /> {state === "busy" ? "Aguarde…" : "Avise-me quando chegar"}
      </button>
      {state === "ios" && (
        <div data-testid="search-alert-ios" className="space-y-3 rounded-2xl border border-white/10 p-4">
          <p className="text-sm text-zinc-300">No iPhone, os avisos funcionam com o site na Tela de Início:</p>
          <InstallSteps />
        </div>
      )}
      {(state === "ios" || state === "fallback") && <WhatsAppAlert query={query} />}
    </div>
  );
};
